import { Nullable } from 'utils/types';
import { Labelled } from 'modules/cm/form/Underwriting/fields';
import { Rows as ViewModelRows, Cell } from 'modules/cm/components/UWTable/UWTable.types';

type Rows<F> = Array<
  Omit<ViewModelRows[0], 'htmlClass' | 'cells'> & {
    htmlClass?: ViewModelRows[0]['htmlClass'];
    cells?: ViewModelRows[0]['cells'];
    field: F;
  }
>;

const createCell = (field: Labelled, value: any): Cell => {
  return {
    htmlClass: 'bold',
    value: field.mapper(value),
  };
};

export const mapToViewModelRows = function<T = Array<object>>(
  rows: Rows<keyof T>,
  data: Nullable<T>[],
  fields: { [key in keyof T]: Labelled },
): ViewModelRows {
  return rows.map(({ htmlClass = null, cells = [], field }) => {
    const prop = field as keyof T;
    const singleField = fields[prop];
    const label = singleField.label;
    const cellsWithValue = data.filter((_) => _).map((field) => createCell(singleField, (field as T)[prop]));

    return {
      htmlClass,
      cells: [
        { htmlClass: 'normal', value: label },
        ...cellsWithValue.map((cell) => {
          return { htmlClass: 'bold', value: cell.value };
        }),
      ],
    };
  });
};
